import { render } from "./footerBar.vue?vue&type=template&id=dc17aeb0"
const script = {}
script.render = render

export default script